module.exports = __webpack_public_path__ + "img/banner-background.e89653b.svg?v=1761300065174";